export const yesterday = 'gisteren';
